import type {Conversation} from "@khan/guide-types";

/**
 * Helper function that returns true if the conversation is considered active.
 */
export const isActiveGuideConversation = (
    conversation: Conversation,
): boolean => conversation.some((message) => message.type === "outgoing");
